import { AccordionRadioGroup } from '../../../../../../types';
import { getSelectedOptionFromGroupOptions } from './getSelectedOptionFromGroupOptions';

export const getSelectedGroup = (
  groups: AccordionRadioGroup[],
  value: string | number,
) =>
  groups.find(
    (group) => !!getSelectedOptionFromGroupOptions(value, group.options),
  );
